import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "donut-chart" }
const _hoisted_2 = {
  class: "h3",
  id: "title"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "location" }, null, -1)
const _hoisted_4 = { class: "figure-content" }
const _hoisted_5 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 50 50",
  class: "donut",
  "aria-labelledby": "title",
  role: "img"
}
const _hoisted_6 = { id: "desc" }
const _hoisted_7 = ["stroke"]
const _hoisted_8 = { class: "figure-key" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "sr-only" }, "Donut chart showing composition of leader types in organisation", -1)
const _hoisted_10 = {
  class: "figure-key-list",
  role: "presentation"
}

import { computed } from "vue";
import { LeaderTypeApiModel } from "../../../api-models";

interface CircleSlice {
  name: string;
  size: number;
  offset: number;
  colour?: string;
}

const CIRCLE_LENGTH = 100;

const RADIUS = 15.91549430918952;


export default /*#__PURE__*/_defineComponent({
  __name: 'donut-chart',
  props: {
    title: {},
    description: {},
    values: {},
    leaderTypeDetails: {},
    membersCount: {}
  },
  setup(__props: any) {

const props = __props;

function getColour(name: string): string | undefined {
  return props.leaderTypeDetails?.find((v) => v.name === name)?.htmlColor;
}

const computedValues = computed<CircleSlice[]>(() => {
  const slices: CircleSlice[] = [];
  let startingPoint = 0;
  Object.keys(props.values).forEach((key) => {
    slices.push({
      name: key,
      size: props.values[key],
      offset: -Math.round(startingPoint * 100) / 100,
      colour: getColour(key),
    });
    startingPoint += props.values[key];
  });

  return slices.sort((a, b) => b.size - a.size);
});

function getSegment(slice: CircleSlice): string {
  return `stroke-dasharray: ${`${slice.size} ${CIRCLE_LENGTH - slice.size}`};
    stroke-dashoffset: ${slice.offset}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.title) + " n=" + _toDisplayString(_ctx.membersCount), 1),
      _hoisted_3
    ]),
    _createElementVNode("figure", null, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock("svg", _hoisted_5, [
          _createElementVNode("desc", _hoisted_6, _toDisplayString(_ctx.description), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedValues.value, (value) => {
            return (_openBlock(), _createElementBlock("circle", {
              class: "donut-segment",
              key: value.name,
              stroke: value.colour,
              "stroke-width": "15",
              fill: "transparent",
              style: _normalizeStyle(getSegment(value)),
              r: RADIUS,
              cx: "25",
              cy: "25"
            }, [
              _createElementVNode("title", null, _toDisplayString(value.name) + " " + _toDisplayString(value.size) + "%", 1)
            ], 12, _hoisted_7))
          }), 128)),
          _createElementVNode("circle", {
            class: "donut-hole",
            r: RADIUS,
            cx: "25",
            cy: "25",
            fill: "#fff",
            role: "presentation"
          })
        ]))
      ]),
      _createElementVNode("figcaption", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedValues.value, (value) => {
            return (_openBlock(), _createElementBlock("li", {
              key: value.name
            }, [
              _createElementVNode("span", {
                class: "shape-circle",
                style: _normalizeStyle({ backgroundColor: value.colour })
              }, null, 4),
              _createTextVNode(_toDisplayString(value.name) + " (" + _toDisplayString(value.size) + " %) ", 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})